import React from "react";

import BookingOverview from "./BookingOverview";
import QuotationOverview from "./QuotationOverview";
import { useEffect } from "react";

const Quote = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <BookingOverview />

      <QuotationOverview />
    </React.Fragment>
  );
};

export default Quote;
